<div class="tireconnect-suppliers-dialog flex-column">
  <!-- Header -->
  <div class="tireconnect-supplier-header flex-row flex-between-center">
    <div class="flex-row flex-start-center">
      <img src="assets/img/tireconnect-cart-logo.png" alt="TireConnect Suppliers" class="mr-1">
      <span class="font-16 font-600">Connected Suppliers</span>
    </div>

    <div class="close-modal pointer" (click)="handleClose()">
      <i class="fal fa-times"></i>
    </div>
  </div>

  <!-- Body -->
  <div class="tireconnect-supplier-body flex-column">
    <div class="flex-row flex-center-center loader-supplier" *ngIf="isLoading">
      <i class="fal fa-spinner rotate font-16 font-gray-45"></i>
    </div>

    <div class="tireconnect-supplier-info flex-column" *ngIf="connectedSuppliers?.length">
      <div class="tireconnect-info-header flex-row">
        <span class="font-14 font-600 p-0 ui-g-6">Suppliers</span>
      </div>

      <div class="tireconnect-info-body flex-row border-bottom-lightest" *ngFor="let supplier  of connectedSuppliers">
        <span class="font-14 font-400 p-0 ui-g-12">{{supplier?.name}}</span>
      </div>
    </div>

    <div class="flex-row flex-center-center loader-supplier" *ngIf="!isLoading && !connectedSuppliers?.length">
      <span class="font-14 font-400 font-secondary">No record exists</span>
    </div>

    <div class="mt-2 flex-row tireconnect-info-msg flex-start-center" *ngIf="connectedSuppliers?.length">
      <i class="far fa-exclamation-triangle icon-warning"></i>
      <span class="font-12 font-400 font-secondary pl-2">
        If you want to connect to more suppliers, please reach out to your account manager
      </span>
    </div>
  </div>

  <!-- Footer -->
  <div class="flex-row tireconnect-supplier-footer flex-end-center">
    <button class="btn btn-primary btn-submit" (click)="handleClose()">
      Close
    </button>
  </div>
</div>
